import { CrowdsecScenarioResponse } from '@bartizo/shared';
import { apiRequest } from './client.js';

/** The scenarios that have fired on a server, a group or the fleet (P11.16). */
export function getCrowdsecScenarios(scope: {
  serverId?: string | undefined;
  groupId?: string | undefined;
}): Promise<CrowdsecScenarioResponse> {
  const params = new URLSearchParams();
  if (scope.serverId !== undefined) params.set('server_id', scope.serverId);
  else if (scope.groupId !== undefined) params.set('group_id', scope.groupId);
  const query = params.toString();
  return apiRequest(`/crowdsec/scenarios${query === '' ? '' : `?${query}`}`, {
    schema: CrowdsecScenarioResponse,
  });
}
